<template>
  <section
    v-if="section"
    class="accruals-estimate-rule-section"
    data-testid="accruals-estimate-rule-section"
  >
    <p class="accruals-estimate-rule-section__kicker">{{ section.kicker || 'Rule Estimate' }}</p>
    <p
      v-if="section.ruleLabel"
      class="accruals-estimate-rule-section__rule-name"
      data-testid="accruals-estimate-rule-section__rule-name"
    >
      {{ section.ruleLabel }}
    </p>
    <div class="accruals-estimate-rule-section__amount-block">
      <p class="accruals-estimate-rule-section__amount">{{ formatCurrency(section.amount) }}</p>
      <p
        v-if="section.subtitle"
        class="accruals-estimate-rule-section__subtitle"
      >
        {{ section.subtitle }}
      </p>
    </div>

    <div
      v-if="section.metrics && section.metrics.length"
      class="accruals-estimate-rule-section__grid"
      data-testid="accruals-estimate-rule-section__grid"
    >
      <div
        v-for="metric in section.metrics"
        :key="metric.label"
        class="accruals-estimate-rule-section__metric"
      >
        <p class="accruals-estimate-rule-section__metric-label">{{ metric.label }}</p>
        <p class="accruals-estimate-rule-section__metric-value">{{ metric.value }}</p>
      </div>
    </div>

    <div
      v-if="section.sourceRows && section.sourceRows.length"
      class="accruals-estimate-rule-section__source"
      data-testid="accruals-estimate-rule-section__source"
    >
      <p class="accruals-estimate-rule-section__source-kicker">Source - From ERP</p>
      <div
        v-for="row in section.sourceRows"
        :key="row.label"
        class="accruals-estimate-rule-section__source-row"
      >
        <span class="accruals-estimate-rule-section__source-label">{{ row.label }}</span>
        <span class="accruals-estimate-rule-section__source-value">{{ row.value }}</span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AccrualsEstimateRuleSection',
  props: {
    section: {
      type: Object,
      default: null,
    },
  },
  methods: {
    formatCurrency(value) {
      if (value === null || value === undefined || value === '') return '—';
      const formatted = this.$nova?.formatNumber
        ? this.$nova.formatNumber(value)
        : String(value);
      return `$${formatted}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './AccrualsEstimateRuleSection.scss';
</style>
